import {EVENT_ADD_TO_CART} from './add-to-cart.js';
import {EVENT_COMMENT} from './comment.js';
import {EVENT_LIKE} from './like.js';
import {EVENT_OFFER} from './offer.js';
const EVENT_BUYING_INTENTION = 'event-buying-intention';
const buyingIntentionEventTrigger = () => {
	document.addEventListener(EVENT_ADD_TO_CART, () =>
			buyingIntentionEventDispatch());
	document.addEventListener(EVENT_COMMENT, () => {
			buyingIntentionEventDispatch()});
	document.addEventListener(EVENT_LIKE, () => {
		buyingIntentionEventDispatch()});
	document.addEventListener(EVENT_OFFER, () => {
		buyingIntentionEventDispatch()});
};

const buyingIntentionEventDispatch = () => {
	const event = new CustomEvent(EVENT_BUYING_INTENTION);
	document.dispatchEvent(event);
}

export {EVENT_BUYING_INTENTION, buyingIntentionEventTrigger};